module.exports = __webpack_public_path__ + "img/teacher08.188fd7f4.jpeg";